<template>
    <div>
        <v-card-actions >
        <v-btn
            color="primary"
            text
            @click="showRelatedItems = !showRelatedItems"
        >
            {{title}}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
            icon
            @click="showRelatedItems = !showRelatedItems"
        >
            <v-icon>{{ showRelatedItems ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
        </v-card-actions>

        <v-expand-transition>
        <div v-show="showRelatedItems">
                <relatedItems :resAmount="resAmount" @getNextResults="getNextResults" class="mx-5" :items="items" :presentCave="presentCave" :preselectedAnnotations="iconography"></relatedItems>
            </div>
        </v-expand-transition>
    </div>
</template>
<script>
import relatedItems from '../components/relatedItems.vue'

export default {
  name: 'hideRelatedItems',
  props: {
    resAmount: {
      type: Number,
      default: 0
    },
    items: {},
    title:"",
    presentCave:{
      type: Boolean,
      default: false
    },
    open:{
      type: Boolean,
      default: true
    },
    iconography:{
      type: Array,
      default: function(){
        return []
      }
    }
  },
  components: {
    relatedItems
  },
  data () {
    return {
      relatedDepictions:[],
      showRelatedItems:this.open
    }
  },
  computed:{
  },
  methods: {
    getNextResults: function(from, size){
      this.$emit("getNextResults", from, size);
    }
  },
  mounted:function () {
    this.$log.debug("hideRelatedItems iconography is:", this.iconography);
  },
}
</script>
<style scoped>

</style>